import { BlogPage } from '@/blog/domain/BlogPage';
import { PostResponse } from '@/blog/domain/BlogResponse';
import { Post } from '@/blog/domain/Post';
import { PostRepository } from '@/blog/domain/PostRepository';
import { PostFilters } from '@/blog/infrastructure/types/PostFilters';
import { SfCmsApiAxios } from '@/shared/infrastructure/SfApiCmsAxios';
import { RawServicesError, ServicesApiResponse } from '@hfc/ui-core';
import { AxiosError } from 'axios';

export class PostApi implements PostRepository {

  public async getFeaturedPost (): Promise<Post> {
    await this.sleep(3000);

    const postResponse: PostResponse = {
      author: {
        id: 1,
        name: 'Health for California',
      },
      title: 'Did You Know Some Health Care Costs Are Tax-Deductible?',
      content: 'If your insurance doesn’t fully cover your medical bills, you may be able to use them to reduce your tax bill. Only some medical costs are tax-deductible, so it’s important to…',
      thumbnail: 'image.png',
      date: 1678994399980,
      slug: 'slug',
    };

    return new Post(postResponse);
  }

  public async getBlogPage (filters: PostFilters): Promise<ServicesApiResponse<BlogPage>> {
    try {
      const request = await SfCmsApiAxios.get(`${import.meta.env.VITE_APP_LEGACY_API_URL}/cms/blog`, { params: filters });

      return {
        success: true,
        data: new BlogPage(request.data)
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawServicesError>
      };
    }
  }

  private sleep (ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
